import { render, staticRenderFns } from "./aroundModal.vue?vue&type=template&id=0c7896f6"
import script from "./aroundModal.vue?vue&type=script&lang=js"
export * from "./aroundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports